import React, { useState, useEffect } from 'react';
import { Shield, LayoutGrid, Layers, Key, Edit2, Plus, Save, X, Trash2, Search } from 'lucide-react';
import Layout from '../../component/layout';


const Modal = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <>
      <div 
        className="modal-backdrop show" 
        style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)', zIndex: 1050 }} 
        onClick={onClose}
      ></div>
      <div className="modal show d-block mt-5" tabIndex="-1" style={{ zIndex: 1055 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg">
            <div className="modal-header border-0 p-4 pb-0">
              <h5 className="modal-title fw-bold text-dark">{title}</h5>
              <button type="button" className="btn-close shadow-none" onClick={onClose}></button>
            </div>
            <div className="modal-body p-4">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const PermissionManagement = () => {
 // --- UI STATE ---
  const [activeTab, setActiveTab] = useState('module');
  const [isModalOpen, setIsModalOpen] = useState(false);


  // --- DATA STATE ---
  const [modules, setModules] = useState([
    { id: 1, name: 'Communication' },
    { id: 2, name: 'Attendance' },
    { id: 3, name: 'Procurement' }
  ]);
  
  const [subModules, setSubModules] = useState([
    { id: 1, moduleId: 1, name: 'ChatBot Admin' },
    { id: 2, moduleId: 2, name: 'Leave Management' },
    { id: 3, moduleId: 3, name: 'Vendor Portal' }
  ]);


  const [permissions, setPermissions] = useState([
    { id: 1, moduleId: 1, subModuleId: 1, name: 'Manage Bots' },
    { id: 2, moduleId: 2, subModuleId: 2, name: 'Approve Leaves' }
  ]);


  // --- FORM STATES ---
  const [moduleForm, setModuleForm] = useState({ name: '' });
  const [editingModuleId, setEditingModuleId] = useState(null);


  const [subModuleForm, setSubModuleForm] = useState({ name: '', moduleId: '' });
  const [editingSubModuleId, setEditingSubModuleId] = useState(null);


  const [permForm, setPermForm] = useState({ name: '', moduleId: '', subModuleId: '' });
  const [editingPermId, setEditingPermId] = useState(null);


  // --- HANDLERS: MODAL CONTROL ---
  const closeModal = () => {
    setIsModalOpen(false);
    setEditingModuleId(null);
    setEditingSubModuleId(null);
    setEditingPermId(null);
    setModuleForm({ name: '' });
    setSubModuleForm({ name: '', moduleId: '' });
    setPermForm({ name: '', moduleId: '', subModuleId: '' });
  };


  // --- HANDLERS: MODULE ---
  const handleSaveModule = (e) => {
    e.preventDefault();
    if (!moduleForm.name.trim()) return;
    if (editingModuleId) {
      setModules(modules.map(m => m.id === editingModuleId ? { ...m, name: moduleForm.name } : m));
    } else {
      setModules([...modules, { id: Date.now(), name: moduleForm.name }]);
    }
    closeModal();
  };


  const editModule = (mod) => {
    setEditingModuleId(mod.id);
    setModuleForm({ name: mod.name });
    setIsModalOpen(true);
  };


  // --- HANDLERS: SUB MODULE ---
  const handleSaveSubModule = (e) => {
    e.preventDefault();
    if (!subModuleForm.name.trim() || !subModuleForm.moduleId) return;
    if (editingSubModuleId) {
      setSubModules(subModules.map(sm => sm.id === editingSubModuleId ? 
        { ...sm, name: subModuleForm.name, moduleId: parseInt(subModuleForm.moduleId) } : sm));
    } else {
      setSubModules([...subModules, { 
        id: Date.now(), 
        name: subModuleForm.name, 
        moduleId: parseInt(subModuleForm.moduleId) 
      }]);
    }
    closeModal();
  };


  const editSubModule = (sm) => {
    setEditingSubModuleId(sm.id);
    setSubModuleForm({ name: sm.name, moduleId: sm.moduleId });
    setIsModalOpen(true);
  };


  // --- HANDLERS: PERMISSION ---
  const handleSavePermission = (e) => {
    e.preventDefault();
    if (!permForm.name.trim() || !permForm.moduleId || !permForm.subModuleId) return;
    if (editingPermId) {
      setPermissions(permissions.map(p => p.id === editingPermId ? 
        { ...p, name: permForm.name, moduleId: parseInt(permForm.moduleId), subModuleId: parseInt(permForm.subModuleId) } : p));
    } else {
      setPermissions([...permissions, { 
        id: Date.now(), 
        name: permForm.name, 
        moduleId: parseInt(permForm.moduleId),
        subModuleId: parseInt(permForm.subModuleId)
      }]);
    }
    closeModal();
  };


  const editPermission = (perm) => {
    setEditingPermId(perm.id);
    setPermForm({ name: perm.name, moduleId: perm.moduleId, subModuleId: perm.subModuleId });
    setIsModalOpen(true);
  };


  // --- HELPERS ---
  const getModuleName = (id) => modules.find(m => m.id === id)?.name || 'Unknown';
  const getSubModuleName = (id) => subModules.find(sm => sm.id === id)?.name || 'Unknown';


  const renderToolbar = (title, onAdd) => (
    <>
      <div className="d-flex justify-content-between align-items-center bg-white p-2 rounded shadow-sm mb-4">
        <h5 className="mb-0 fw-bold px-2 text-dark d-flex align-items-center">{title}</h5>
        <button style={{color: "#53b7e8", border: "1px solid #53b7e8"}} className="btn rounded px-1 fw-medium d-flex align-items-center bg-white" onClick={onAdd}>
          <Plus size={16} className="me-1" /> Add {title}
        </button>
      </div>
      
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-3 align-items-center">
         <div 
  style={{ 
    display: 'flex', 
    alignItems: 'center', 
    width: '190px', 
    backgroundColor: '#ffffff', 
    borderRadius: '5px', 
    padding: '0px 5px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)' // Soft shadow without border
  }}
>
  {/* Icon - No border, No bg */}
  <div style={{ color: '#6c757d', display: 'flex', alignItems: 'center' }}>
    <Search size={16} />
  </div>

  {/* Input - Completely reset */}
  <input 
    type="text" 
    placeholder={`Search ${title}`} 
    style={{ 
      border: 'none', 
      outline: 'none', 
      background: 'transparent', 
      width: '100%', 
      padding: '8px 10px',
      fontSize: '14px',
      color: '#333'
    }} 
  />
</div>
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted small">Entries per page</span>
            <select className="form-select rounded border-0 shadow-sm text-dark small" style={{ width: '80px' }}>
              <option>25</option>
            </select>
          </div>
        </div>
      
      </div>
    </>
  );


  return (
    <Layout>
    <div className=" font-sans" style={{ fontFamily: 'system-ui, -apple-system, sans-serif'}}>
      
      {/* Main Content Area */}
      <div className="container-fluid py-4">


        {/* Tab Navigation */}
        <div className="d-flex mb-4 gap-3">
          {['module', 'submodule', 'permission'].map((tab) => (
           <button 
  key={tab}
  className={`btn rounded px-4 py-2 fw-medium border-0 shadow-sm transition-all ${
    activeTab === tab ? 'text-white' : 'bg-white text-dark'
  }`} 
  style={{ 
    backgroundColor: activeTab === tab ? '#53b7e8' : '#ffffff' 
  }}
  onClick={() => setActiveTab(tab)}
>
  {tab.charAt(0).toUpperCase() + tab.slice(1).replace('module', ' Module')}s
</button>
          ))}
        </div>


        {/* --- TABLES --- */}
        {activeTab === 'module' && (
          <>
            {renderToolbar('Module', () => setIsModalOpen(true))}
            <div className="table-responsive rounded" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
               <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
      <tr>
        <th className="border-0 py-2 text-dark px-4" style={{ width: '10%', backgroundColor: 'white' }}>Sr. no</th>
        <th className="border-0 py-2 text-dark" style={{ width: '60%', backgroundColor: 'white' }}>Module Name</th>
        <th className="border-0 py-2 text-dark px-4" style={{ width: '30%', backgroundColor: 'white' }}>Action</th>
      </tr>
    </thead>
                <tbody>
                  {modules.map((mod, index) => (
                    <tr key={mod.id} className="shadow-sm">
                      <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{index + 1}</td>
                      <td className="bg-white border-0 py-2 text-dark fw-medium">{mod.name}</td>
                      <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                        <button onClick={() => editModule(mod)} className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                        <button className="btn btn-link text-danger p-0"><Trash2 size={16} /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}


        {activeTab === 'submodule' && (
          <>
            {renderToolbar('Sub Module', () => setIsModalOpen(true))}
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                  <tr>
                    <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '10%' }}>Sr. no</th>
                    <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '40%' }}>Sub Module</th>
                    <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '30%' }}>Parent Module</th>
                    <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '20%' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {subModules.map((sm, index) => (
                    <tr key={sm.id} className="shadow-sm">
                      <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{index + 1}</td>
                      <td className="bg-white border-0 py-2 text-dark fw-medium">{sm.name}</td>
                      <td className="bg-white border-0 py-2text-secondary">{getModuleName(sm.moduleId)}</td>
                      <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                        <button onClick={() => editSubModule(sm)} className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                        <button className="btn btn-link text-danger p-0"><Trash2 size={16} /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}


        {activeTab === 'permission' && (
          <>
            {renderToolbar('Permission', () => setIsModalOpen(true))}
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table" style={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}> 
                  <tr>
                    <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '10%' }}>Sr. no</th>
                    <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '30%' }}>Permission</th>
                    <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '20%' }}>Module</th>
                    <th className="border-0 py-2 bg-white text-dark py-2" style={{ width: '20%' }}>Sub Module</th>
                    <th className="border-0 py-2 bg-white text-dark px-4 py-2" style={{ width: '20%' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {permissions.map((perm, index) => (
                    <tr key={perm.id} className="shadow-sm">
                      <td className="bg-white border-0 py-2 px-4 rounded-start-1 text-muted">{index + 1}</td>
                      <td className="bg-white border-0 py-2 text-dark fw-medium">{perm.name}</td>
                      <td className="bg-white border-0 py-2 text-secondary">{getModuleName(perm.moduleId)}</td>
                      <td className="bg-white border-0 py-2 text-secondary">{getSubModuleName(perm.subModuleId)}</td>
                      <td className="bg-white border-0 py-2 px-4 rounded-end-1">
                        <button onClick={() => editPermission(perm)} className="btn btn-link text-primary p-0 me-3"><Edit2 size={16} /></button>
                        <button className="btn btn-link text-danger p-0"><Trash2 size={16} /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>


      {/* --- MODAL WINDOW POPUP --- */}
      <Modal 
        isOpen={isModalOpen}
        onClose={closeModal}
        title={`${editingModuleId || editingSubModuleId || editingPermId ? 'Update' : 'Create'} ${activeTab.charAt(0).toUpperCase() + activeTab.slice(1).replace('module', ' Module')}`}
      >
        {activeTab === 'module' && (
          <form onSubmit={handleSaveModule}>
            <div className="mb-4">
              <label className="form-label text-muted small fw-bold">Module Name</label>
              <input type="text" className="form-control rounded-3 border-0 bg-light p-3 shadow-none" placeholder="e.g. Human Resource" value={moduleForm.name} onChange={(e) => setModuleForm({name: e.target.value})} required />
            </div>
            <div className="d-flex gap-2 justify-content-end mt-4">
              <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
              <button type="submit" className="btn btn-primary rounded-pill px-4"><Save size={16} className="me-2" />{editingModuleId ? 'Update' : 'Save'}</button>
            </div>
          </form>
        )}


        {activeTab === 'submodule' && (
          <form onSubmit={handleSaveSubModule}>
            <div className="mb-3">
              <label className="form-label text-muted small fw-bold">Select Module</label>
              <select className="form-select rounded-3 border-0 bg-light p-3 shadow-none" value={subModuleForm.moduleId} onChange={(e) => setSubModuleForm({...subModuleForm, moduleId: e.target.value})} required>
                <option value="">-- Choose Parent --</option>
                {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="form-label text-muted small fw-bold">Sub Module Name</label>
              <input type="text" className="form-control rounded-3 border-0 bg-light p-3 shadow-none" placeholder="e.g. Payroll" value={subModuleForm.name} onChange={(e) => setSubModuleForm({...subModuleForm, name: e.target.value})} required />
            </div>
            <div className="d-flex gap-2 justify-content-end mt-4">
              <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
              <button type="submit" className="btn btn-primary rounded-pill px-4"><Save size={16} className="me-2" />{editingSubModuleId ? 'Update' : 'Save'}</button>
            </div>
          </form>
        )}


        {activeTab === 'permission' && (
          <form onSubmit={handleSavePermission}>
            <div className="mb-3">
              <label className="form-label text-muted small fw-bold">Select Module</label>
              <select className="form-select rounded-3 border-0 bg-light p-3 shadow-none" value={permForm.moduleId} onChange={(e) => setPermForm({...permForm, moduleId: e.target.value, subModuleId: ''})} required>
                <option value="">-- Choose Module --</option>
                {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label text-muted small fw-bold">Select Sub Module</label>
              <select className="form-select rounded-3 border-0 bg-light p-3 shadow-none" value={permForm.subModuleId} onChange={(e) => setPermForm({...permForm, subModuleId: e.target.value})} required disabled={!permForm.moduleId}>
                <option value="">-- Choose Sub Module --</option>
                {subModules.filter(sm => sm.moduleId === parseInt(permForm.moduleId)).map(sm => <option key={sm.id} value={sm.id}>{sm.name}</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="form-label text-muted small fw-bold">Permission Name</label>
              <input type="text" className="form-control rounded-3 border-0 bg-light p-3 shadow-none" placeholder="e.g. Edit Records" value={permForm.name} onChange={(e) => setPermForm({...permForm, name: e.target.value})} required />
            </div>
            <div className="d-flex gap-2 justify-content-end mt-4">
              <button type="button" className="btn btn-light rounded-pill px-4" onClick={closeModal}>Cancel</button>
              <button type="submit" className="btn btn-primary rounded-pill px-4"><Save size={16} className="me-2" />{editingPermId ? 'Update' : 'Save'}</button>
            </div>
          </form>
        )}
      </Modal>


    </div>
    </Layout>

  )
}

export default PermissionManagement